import VueScrollTo from 'vue-scrollto'

const DEFAULT_OPTIONS = {
  easing: 'ease-in',
  offset: -60,
  force: true,
  cancelable: true
}

export const scrollTo = (elm, options = {}) => {
  const duration = options.duration || 500
  VueScrollTo.scrollTo(elm, duration, { ...options, ...DEFAULT_OPTIONS })
}

export const scrollToTop = (options = {}) => {
  scrollTo('head', options)
}
